import { Outlet } from 'react-router'
import { AuthContextType } from 'pages/Auth/types.ts'
import AuthContainer from 'components/AuthContainer/AuthContainer.tsx'
import { useStoreSelector } from 'hooks/store.ts'

const Auth = () => {
  // REDUX STORE
  const { loading, error } = useStoreSelector((store) => store.auth)

  return (
    <AuthContainer>
      <Outlet context={{ loading, error } satisfies AuthContextType} />
    </AuthContainer>
  )
}

export default Auth
